import { useLiqpayStore } from '~/stores/liqpay';
import { defineStore } from 'pinia'

const emptyCart = {
    cartState: 'cart',
    id: null,
    company: null,
    expire: null,
    items: [],
    total: {
        amount: 0,
        string: 'Жодного товару'
    }
}

export const useCartStore = defineStore({
    id: 'cart',

    state () {
        return {
            carts: [],

            forceRefresh: false,
            activeCartIndex: 0,
        }
    },

    getters: {
        isEmpty () {
            return !this.itemsLength;
        },

        activeCart (state) {
            return state.carts[state.activeCartIndex] || emptyCart;
        },

        itemsLength (state) {
            let number = 0;
            state.carts.forEach(cart => number += cart.items ? cart.items.length : 0);

            return number;
        },

        nonEmptyCartsLength (state) {
            let number = 0;

            for (const cart of state.carts) {
                if (cart.items?.length > 0) number++;
            }

            return number;
        },

        nonEmptyCartIndex (state) {
            return state.carts.findIndex(cart => cart.items?.length > 0);
        },

    },

    actions: {
        setActiveCartIndex (index = 0) {
            if (!this.carts[index]) index = 0;
            this.activeCartIndex = index;
        },

        setCartState (cartState) {
            this.carts[this.activeCartIndex].cartState = cartState;
        },

        updateCart (payload) {
            payload.cartState = 'cart';
            if (payload.expireAt) payload.expireAt = new Date(payload.expireAt);

            let index = -1;

            if (payload.company) {
                index = this.carts.findIndex(cart => {
                    return cart.company && cart.company.id == payload.company.id;
                });
            } else {
                index = this.carts.findIndex(cart => !cart.company);
            }

            payload.cartState = 'cart';
            if (index >= 0 && this.carts[index].cartState == 'bill-editor') {
                payload.cartState = 'bill-editor';
            }

            if (index < 0) {
                return this.carts.push(payload);
            }

            this.carts.splice(index, 1, payload);
        },

        updateCarts (payload) {
            this.carts = [];


            payload.forEach(cart => {
                if (cart.expireAt) cart.expireAt = new Date(cart.expireAt);
                cart.cartState = 'cart';

                this.carts.push(cart);
            })
        },

        clear () {
            this.activeCart.items = [];
            this.activeCart.expire = null;
            this.activeCart.total = {
                amount: 0,
                string: 'Жодного товару'
            }
        },

        subscribe ({ slug, price, referral = null }) {
            const liqpayStore = useLiqpayStore();
            liqpayStore.setSubscription({liqpay: 'subscription', slug, price, referral});

            this.$nuxt.$modalityStore.openModal({type: 'cart', name: 'subscription'});
        }
    }
})
